import { createContext, PropsWithChildren, useContext } from "react";
import { Frontmatter } from "../../mdx-pages/types/fontmatter";

type PageData = {
  frontmatter: Frontmatter;
};

export const PageDateContext = createContext<PageData | null>(null);

export const usePageData = (): PageData => {
  const context = useContext(PageDateContext);
  if (!context) {
    throw new Error("usePageData must be used within a PageDataProvider");
  }
  return context;
};

export const PageDataProvider = ({
  frontmatter,
  children,
}: PropsWithChildren<PageData>) => {
  return (
    <PageDateContext.Provider value={{ frontmatter }}>
      {children}
    </PageDateContext.Provider>
  );
};
